import RootLanding from '../../components/layouts/RootLanding';
import heroBeranda from '../../assets/publik/hero-beranda.jpg';
import { Wadah } from '../../components/fragments/landing/publik/Elemen';
import { HeroMisi, SeksiBeritaTerbaru, SeksiFaq, SeksiGaleri } from '../../components/fragments/landing/publik/Seksi';

/*
 * Beranda publik sesuai frame Figma "Direktorat Pengelolaan B3 — Beranda"
 * (Nov 2026): hero misi, tiga berita/artikel terbaru, pita galeri, lalu FAQ.
 * Pintasan ikon lama (Pelayanan, Database, Info & Motivasi Merkuri) tidak ada di
 * desain baru; Database dan Merkuri kini ditautkan dari halaman Informasi Merkuri.
 */
export default function HomePage() {
    return (
        <RootLanding>
            <HeroMisi
                judul="Pusat Informasi Layanan dan Pelaporan B3"
                pengantar="Portal layanan dan informasi digital pengelolaan B3 untuk mendukung kemudahan berusaha, transparansi, serta perlindungan lingkungan dan kesehatan masyarakat."
                gambar={heroBeranda}
            />
            <section className="bg-white">
                <Wadah className="py-[72px]">
                    <SeksiBeritaTerbaru />
                </Wadah>
            </section>
            <SeksiGaleri />
            <SeksiFaq />
        </RootLanding>
    );
}
